module.exports = __webpack_public_path__ + "static/media/equipamentos_amamentacao.b7a9bc32.jpg";